import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Trash2, AlertTriangle, CheckCircle } from 'lucide-react';
import api from '../api/client';

export default function DataDeletion() {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/data-deletion-request', { email, reason });
      setSubmitted(true);
    } catch (err) {
      setSubmitted(true);
    }
    setLoading(false);
  };

  const Header = () => (
    <header className="px-8 lg:px-16 py-5 flex items-center justify-between" style={{borderBottom:'1px solid var(--border-color)'}}>
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="AHOOW" className="h-10 w-10 rounded-xl" />
        <span className="text-2xl font-black tracking-wide" style={{color:'var(--text-primary)'}}>AH<span className="text-brand-pink">OO</span>W</span>
      </div>
      <Link to="/" className="text-sm flex items-center gap-2 hover:opacity-70" style={{color:'var(--text-muted)'}} data-testid="deletion-back"><ArrowLeft size={16} /> Retour</Link>
    </header>
  );

  if (submitted) {
    return (
      <div className="min-h-screen" style={{background:'var(--bg-primary)'}}>
        <Header />
        <div className="max-w-xl mx-auto px-8 py-20 text-center">
          <CheckCircle size={64} className="text-green-400 mx-auto mb-6" />
          <h1 className="text-2xl font-black mb-4" style={{color:'var(--text-primary)'}}>Demande envoyee</h1>
          <p className="leading-relaxed" style={{color:'var(--text-secondary)'}}>
            Votre demande de suppression de donnees a ete enregistree. Nous traiterons votre demande dans un delai de <strong style={{color:'var(--text-primary)'}}>30 jours</strong>.
          </p>
          <Link to="/" className="inline-block mt-8 text-brand-violet hover:opacity-70 font-semibold text-sm">Retour a l'accueil</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{background:'var(--bg-primary)'}}>
      <Header />
      <div className="max-w-xl mx-auto px-8 py-12">
        <div className="flex items-center gap-3 mb-4">
          <Trash2 size={28} className="text-red-400" />
          <h1 className="text-3xl font-black" style={{color:'var(--text-primary)'}}>Suppression des donnees</h1>
        </div>
        <p className="mb-8" style={{color:'var(--text-secondary)'}}>Conformement au RGPD et au CCPA, vous pouvez demander la suppression complete de vos donnees personnelles.</p>

        <div className="glass-card p-5 mb-6">
          <div className="flex items-start gap-3">
            <AlertTriangle size={20} className="text-amber-400 shrink-0 mt-0.5" />
            <div>
              <h3 className="text-sm font-bold mb-1" style={{color:'var(--text-primary)'}}>Cette action est irreversible</h3>
              <p className="text-sm" style={{color:'var(--text-muted)'}}>La suppression inclut : profil, photos, messages, matchs et toutes les donnees associees.</p>
            </div>
          </div>
        </div>

        {error && <div className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3 mb-6">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium mb-2" style={{color:'var(--text-secondary)'}}>Email associe a votre compte *</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" placeholder="votre@email.com" required data-testid="deletion-email" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2" style={{color:'var(--text-secondary)'}}>Raison (optionnel)</label>
            <textarea value={reason} onChange={(e) => setReason(e.target.value)} className="input-field min-h-[80px] resize-none" placeholder="Dites-nous pourquoi..." data-testid="deletion-reason" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-4 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold text-base transition-all disabled:opacity-50" data-testid="deletion-submit">
            {loading ? 'Envoi en cours...' : 'Demander la suppression de mes donnees'}
          </button>
        </form>
      </div>
    </div>
  );
}
